import { ButtonComponentProps } from "@omni/ui/components/Button/button.props";

import { button } from "./button.style";

export const Button = ({
    ref: buttonRef,
    form,
    stopPropagation = true,
    tabIndex,
    className,
    size,
    color,
    outline,
    fullWidth,
    disabled = false,
    loading = false,
    type = "button",
    test,
    dataAttributes,
    "aria-label": ariaLabel,
    onClick,
    children,
    ...buttonHtmlAttributes
}: ButtonComponentProps) => {
    return (
        <button
            {...buttonHtmlAttributes}
            aria-label={ariaLabel}
            data-test={test}
            type={type}
            form={form}
            className={button({
                size,
                color,
                outline,
                fullWidth,
                loading,
                className
            })}
            onClick={(e) => {
                if (stopPropagation) {
                    e.stopPropagation();
                }

                onClick?.(e);
            }}
            disabled={disabled || loading}
            ref={buttonRef}
            tabIndex={tabIndex}
            {...dataAttributes}
        >
            {children}
        </button>
    );
};
